/**
 * @file コンポーネント：お知らせリスト DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledNewslist,
    StyledNewslistAnchor,
    StyledNewslistDate,
    StyledNewslistItem,
    StyledNewslistMore,
    StyledNewslistTitle,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledNewslist>
            {props.list.map((item, index) => (
                <StyledNewslistItem key={"news-" + index}>
                    {item.url !== "" ? (
                        <StyledNewslistAnchor
                            href={item.url}
                            target={item.target}
                        >
                            <StyledNewslistDate dateTime={item.dateTime}>
                                {item.date}
                            </StyledNewslistDate>
                            <StyledNewslistTitle>
                                {item.title}
                            </StyledNewslistTitle>
                        </StyledNewslistAnchor>
                    ) : (
                        <>
                            <StyledNewslistDate dateTime={item.dateTime}>
                                {item.date}
                            </StyledNewslistDate>
                            <StyledNewslistTitle>
                                {item.title}
                            </StyledNewslistTitle>
                        </>
                    )}
                </StyledNewslistItem>
            ))}
            {props.hasNext && (
                // 以降のお知らせがある場合のみmoreボタンを出力
                <StyledNewslistItem>
                    <StyledNewslistMore
                        onClick={(e) => {
                            e.preventDefault();
                            props.setLimit(props.limit + 10);
                        }}
                        type="button"
                    >
                        {localized["Label.MoreNews"]}
                    </StyledNewslistMore>
                </StyledNewslistItem>
            )}
        </StyledNewslist>
    );
};
